// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1w3eP","title":"BackImages_title__387Vk","images":"BackImages_images__O4jTs"};